import { Record, List, fromJS } from 'immutable'
import _ from 'lodash'

import { HISTORY_LOADED, LOAD_HISTORY_REQUEST, LOAD_HISTORY_REQUEST_SUCCESS } from './constants'

const initialState = Record({
    loading: false,
    loaded: false,
    entities: List(),
})

export default function historyReducer(state = initialState(), action = {}) {
    switch (action.type) {
        case LOAD_HISTORY_REQUEST: {
            return state.set('loading', true).set('loaded', false)
        }

        case LOAD_HISTORY_REQUEST_SUCCESS: {
            return state.set('loading', false).set('loaded', true)
        }
        case HISTORY_LOADED: {
            const entities = fromJS(_.get(action, 'data.entities', []))

            return state.set('entities', entities)
        }
        default:
            return state
    }
}
